import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Download, Loader2, Smartphone } from "lucide-react";
import { downloadApk } from "@/lib/download-apk";
import { useToast } from "@/hooks/use-toast";

const isMobile = () => /Android|iPhone/i.test(navigator.userAgent);

export function InstallApkDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  const { toast } = useToast();
  const [downloading, setDownloading] = useState(false);
  const mobile = isMobile();

  const handleDownload = async () => {
    setDownloading(true);
    try {
      await downloadApk();
    } catch (err) {
      toast({ title: (err as Error).message, variant: "destructive" });
    } finally {
      setDownloading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Smartphone className="w-5 h-5 text-primary" />
            Como instalar o app
          </DialogTitle>
          <DialogDescription>
            O LaudoLegal é distribuído como arquivo .apk, fora da Play Store.
          </DialogDescription>
        </DialogHeader>

        {!mobile && (
          <p className="text-sm rounded-lg bg-amber-50 text-amber-800 px-3 py-2">
            Para agilizar, abra este site pelo celular e toque em "Baixar o
            App" direto por lá.
          </p>
        )}

        <ol className="space-y-3 text-sm text-slate-700 list-decimal list-inside">
          <li>Toque em "Baixar agora" abaixo para baixar o arquivo .apk.</li>
          <li>
            Ao abrir o arquivo baixado, o Android vai pedir permissão para
            instalar de "fontes desconhecidas" — toque em{" "}
            <strong>Configurações</strong> e ative essa opção para o
            navegador/gerenciador de arquivos usado.
          </li>
          <li>Volte e toque em instalar novamente para concluir.</li>
        </ol>

        <DialogFooter>
          <Button onClick={handleDownload} disabled={downloading} className="w-full">
            {downloading ? (
              <Loader2 className="w-4 h-4 mr-2 animate-spin" />
            ) : (
              <Download className="w-4 h-4 mr-2" />
            )}
            Baixar agora
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
